const nexcess = {
  logo: require("@/assets/nexcess-logo.svg"),
  login_top: require("@/assets/logo-nex-lw-white.svg"),
  cdn_info_link: "https://help.nexcess.net/77208-cdn/what-is-a-content-delivery-network-cdn",
};

export default nexcess;
